var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { gqlSdk } from '@cta-portal/webapp-common/lib/api/client';
import { CardAdvancement, CardRarity, } from '@cta-portal/webapp-common/lib/api/schema';
import { useI18n } from '@cta-portal/webapp-common/lib/hooks/translations/use-i18n';
import { ethers } from 'ethers';
import { useContext, useEffect, useState } from 'react';
import { MarketDetailsTab } from '../../app/router/config';
import cardTypeIcon from '../../assets/images/icons/common/icon-card-type-gold.png';
import stoneIcon from '../../assets/images/icons/common/icon-eternal-stone.png';
import triselIcon from '../../assets/images/icons/common/icon-trisel.png';
import { CurrencyContext } from '../../context/currency';
import { DialogContext } from '../../context/dialog';
import { LoadingContext } from '../../context/loading';
import { UserContext } from '../../context/user';
import { CurrencyTokenSymbol } from '../../data/currency-tokens/currency-tokens';
import cardsData from '../../data/products/cards.json';
import { appEnv } from '../../env';
import { SortDirection, TokenType } from '../../types/common';
import { DialogType } from '../../types/dialogs';
import { sleep } from '../../utils/async';
import { checkIfWalletAsEnoughCurrency } from '../../utils/balances';
import { strFloatToTokenQuantity } from '../../utils/blockchain';
import { advancementAssets, elementAssets, factionAssets, foilAssets, gradeAssets, rankAssets, rarityAssets, } from '../../utils/cards-metadata-assets';
import { getAssetFloorPrice, getImxOrders } from '../../utils/imx-orders';
import { getFormatedSupply } from '../../utils/supply';
import { useInput } from '../common/use-input';
import { useImxActions } from '../imx/use-imx-actions';
export function useAsset(tokenId, filters, tab) {
    var t = useI18n().t;
    var setImxLoading = useContext(LoadingContext).setImxLoading;
    var setDialogProps = useContext(DialogContext).setDialogProps;
    var _a = useContext(UserContext), user = _a.user, balances = _a.balances, getBalances = _a.getBalances, localWalletAddress = _a.localWalletAddress, fees = _a.fees, selectedWallet = _a.selectedWallet;
    var _b = useContext(CurrencyContext), tokens = _b.tokens, usdcAddress = _b.usdcAddress, imxClient = _b.imxClient, queue = _b.queue, parseCurrencyQuantity = _b.parseCurrencyQuantity;
    var imxActions = useImxActions();
    var _c = useState(undefined), asset = _c[0], setAsset = _c[1];
    var _d = useState(false), initialized = _d[0], setInitialized = _d[1];
    var _e = useState(undefined), assetOrder = _e[0], setAssetOrder = _e[1];
    var _f = useState(undefined), order = _f[0], setOrder = _f[1];
    var _g = useState(undefined), price = _g[0], setPrice = _g[1];
    var _h = useState(false), notEnoughCurrency = _h[0], setNotEnoughCurrency = _h[1];
    var makeOfferPrice = useInput('');
    var _j = useState(CurrencyTokenSymbol.USDC), listForSaleCurrencyTokenSymbol = _j[0], setListForSaleCurrencyTokenSymbol = _j[1];
    var listForSalePrice = useInput('');
    var walletToTransferAddress = useInput('');
    var _k = useState(false), ownedByUser = _k[0], setOwnedByUser = _k[1];
    var _l = useState(null), onSaleOrders = _l[0], setOnSaleOrders = _l[1];
    var _m = useState(null), displayedOnSaleOrders = _m[0], setDisplayedOnSaleOrders = _m[1];
    var _o = useState(undefined), offers = _o[0], setOffers = _o[1];
    var _p = useState(null), recentlySoldOrders = _p[0], setRecentlySoldOrders = _p[1];
    var _q = useState(null), displayedRecentlySoldOrders = _q[0], setDisplayedRecentlySoldOrders = _q[1];
    var _r = useState({ cta: undefined, usdc: undefined }), cursors = _r[0], setCursors = _r[1];
    var _s = useState({ cta: -1, usdc: -1 }), remainings = _s[0], setRemainings = _s[1];
    var _t = useState(0), refreshCount = _t[0], setRefreshCount = _t[1];
    var _u = useState(undefined), relatedContent = _u[0], setRelatedContent = _u[1];
    var _v = useState(undefined), shredPreview = _v[0], setShredPreview = _v[1];
    var _w = useState(undefined), floorPrice = _w[0], setFloorPrice = _w[1];
    var _x = useState(undefined), supply = _x[0], setSupply = _x[1];
    var _y = useState(undefined), myOffer = _y[0], setMyOffer = _y[1];
    useEffect(function () {
        refetchAsset();
        getMyOffer();
    }, [selectedWallet, imxClient, tokenId, fees, usdcAddress]);
    useEffect(function () {
        setOnSaleOrders(null);
        setDisplayedOnSaleOrders(null);
        setRecentlySoldOrders(null);
        setDisplayedRecentlySoldOrders(null);
        if (asset && tab === MarketDetailsTab.ON_SALE) {
            getOnSaleOrders({ options: { refresh: true }, assetData: asset });
        }
        else if (asset && tab === MarketDetailsTab.ACTIVITY) {
            getOffers();
            getRecentlySoldOrders({ options: { refresh: true }, assetData: asset });
        }
    }, [usdcAddress, filters.state.currencyTokens, asset, fees, imxClient, tab]);
    useEffect(function () {
        setCursors({ cta: undefined, usdc: undefined });
        setRemainings({ cta: -1, usdc: -1 });
    }, [tab]);
    useEffect(function () {
        if (!order || !selectedWallet)
            return;
        var hasEnoughCurrency = checkIfWalletAsEnoughCurrency(user, balances, selectedWallet, localWalletAddress, parseCurrencyQuantity, order.buy.data.token_address || '', order.buy.data.quantity_with_fees);
        setNotEnoughCurrency(!hasEnoughCurrency);
    }, [user, order, selectedWallet, balances, localWalletAddress]);
    useEffect(function () {
        if (!tokens || !order || !selectedWallet)
            return;
        var hasEnoughCurrency = makeOfferPrice.value.length > 0
            ? checkIfWalletAsEnoughCurrency(user, balances, selectedWallet, localWalletAddress, parseCurrencyQuantity, order.buy.data.token_address || '', strFloatToTokenQuantity(makeOfferPrice.value, tokens, order.buy.data.token_address || ''))
            : true;
        var makeOfferPriceTooLow = price
            ? Number.parseFloat(makeOfferPrice.value.replaceAll(',', '')) <
                Number.parseFloat(price.value.replaceAll(',', '')) * 0.1
            : false;
        setDialogProps(function (value) {
            return (value === null || value === void 0 ? void 0 : value.custom.type) === DialogType.MAKE_OFFER
                ? {
                    common: __assign(__assign({}, value.common), { actions: [
                            {
                                highlighted: true,
                                text: t('common.confirm'),
                                action: value.custom.update ? function () { return updateOffer(makeOfferPrice); } : function () { return makeOffer(makeOfferPrice); },
                                disabled: !hasEnoughCurrency ||
                                    makeOfferPriceTooLow ||
                                    makeOfferPrice.value.length === 0 ||
                                    Number.parseFloat(makeOfferPrice.value) === 0,
                            },
                        ] }),
                    custom: __assign(__assign({}, value.custom), { makeOfferPrice: makeOfferPrice, notEnoughCurrency: !hasEnoughCurrency, makeOfferPriceTooLow: makeOfferPriceTooLow }),
                }
                : value;
        });
    }, [user, order, price, makeOfferPrice.value, selectedWallet, balances, localWalletAddress]);
    useEffect(function () {
        setDialogProps(function (value) {
            return value && value.custom.type === DialogType.LIST_FOR_SALE_SINGLE
                ? {
                    common: __assign(__assign({}, value.common), { actions: [
                            {
                                highlighted: true,
                                text: t('common.confirm'),
                                action: function () {
                                    return listForSale(listForSalePrice, listForSaleCurrencyTokenSymbol, value.custom.type === DialogType.LIST_FOR_SALE_SINGLE ? value.custom.edit : undefined);
                                },
                                disabled: listForSalePrice.value.length === 0 || Number.parseFloat(listForSalePrice.value) === 0,
                            },
                        ] }),
                    custom: __assign(__assign({}, value.custom), { currencyTokenSymbol: listForSaleCurrencyTokenSymbol, price: listForSalePrice }),
                }
                : value;
        });
    }, [listForSaleCurrencyTokenSymbol, listForSalePrice.value]);
    useEffect(function () {
        setDialogProps(function (value) {
            return (value === null || value === void 0 ? void 0 : value.custom.type) === DialogType.LIST_FOR_SALE_SINGLE
                ? {
                    common: __assign(__assign({}, value.common), { actions: [
                            {
                                highlighted: true,
                                text: t('common.confirm'),
                                disabled: true,
                            },
                        ] }),
                    custom: __assign(__assign({}, value.custom), { currencyTokenSymbol: listForSaleCurrencyTokenSymbol, price: __assign(__assign({}, listForSalePrice), { value: '' }) }),
                }
                : value;
        });
        listForSalePrice.setValue('');
    }, [listForSaleCurrencyTokenSymbol]);
    useEffect(function () {
        var invalidAddress = walletToTransferAddress.value.length === 0 ? false : !ethers.isAddress(walletToTransferAddress.value);
        setDialogProps(function (value) {
            return (value === null || value === void 0 ? void 0 : value.custom.type) === DialogType.TRANSFER_ASSET
                ? {
                    common: __assign(__assign({}, value.common), { actions: [
                            {
                                highlighted: true,
                                text: t('common.confirm'),
                                action: function () { return transfer(walletToTransferAddress); },
                                disabled: walletToTransferAddress.value.length === 0 || invalidAddress,
                            },
                        ] }),
                    custom: __assign(__assign({}, value.custom), { walletToAddress: walletToTransferAddress, invalidAddress: invalidAddress }),
                }
                : value;
        });
    }, [walletToTransferAddress.value]);
    function refetchAsset() {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all([getAsset(), getAssetOrder()])];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    }
    function getAsset() {
        return __awaiter(this, void 0, void 0, function () {
            var response, metadata, productCard, cardRelatedContent, cardSupplyResponse, _a, cardShredData, _b, floorPriceMetadata, floorPriceOrder, _loop_1, _i, _c, ian, foundRelatedProductCard, _loop_2, _d, foundRelatedProductCard_1, card;
            var _e, _f;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        if (!imxClient || !usdcAddress || !fees)
                            return [2 /*return*/];
                        setImxLoading(true);
                        return [4 /*yield*/, queue.add(function () {
                                return imxClient.getAsset({
                                    tokenAddress: appEnv.blockchain.collectionAddress,
                                    tokenId: tokenId,
                                });
                            })];
                    case 1:
                        response = _g.sent();
                        metadata = response ? response.metadata : undefined;
                        productCard = (metadata === null || metadata === void 0 ? void 0 : metadata.tokenType) === TokenType.CARD ? cardsData.find(function (card) { return card.ian === metadata.ian; }) : undefined;
                        cardRelatedContent = [];
                        if (!((metadata === null || metadata === void 0 ? void 0 : metadata.tokenType) === TokenType.CARD && metadata.ian)) return [3 /*break*/, 3];
                        return [4 /*yield*/, gqlSdk.MpCardSupplyFindByIan({ input: { ian: metadata.ian } })];
                    case 2:
                        _a = _g.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        _a = undefined;
                        _g.label = 4;
                    case 4:
                        cardSupplyResponse = _a;
                        setSupply(cardSupplyResponse && (metadata === null || metadata === void 0 ? void 0 : metadata.advancement)
                            ? getFormatedSupply(metadata.advancement, cardSupplyResponse.mpCardSupplyFindByIan.cards)
                            : undefined);
                        if (!((metadata === null || metadata === void 0 ? void 0 : metadata.tokenType) === TokenType.CARD &&
                            (metadata === null || metadata === void 0 ? void 0 : metadata.rarity) !== CardRarity.EXCLUSIVE &&
                            metadata.CardRarity !== CardRarity.UNIQUE)) return [3 /*break*/, 6];
                        return [4 /*yield*/, gqlSdk.MpCardWithDisenchantPreviewFindMany({ input: { tokenIds: [Number.parseInt(tokenId)] } })];
                    case 5:
                        _b = _g.sent();
                        return [3 /*break*/, 7];
                    case 6:
                        _b = undefined;
                        _g.label = 7;
                    case 7:
                        cardShredData = _b;
                        setShredPreview((cardShredData === null || cardShredData === void 0 ? void 0 : cardShredData.mpCardWithDisenchantPreviewFindMany) && cardShredData.mpCardWithDisenchantPreviewFindMany.length > 0
                            ? {
                                stonesCount: cardShredData.mpCardWithDisenchantPreviewFindMany[0].disenchantPreview.stoneEternal,
                                triselsCount: cardShredData.mpCardWithDisenchantPreviewFindMany[0].disenchantPreview.freeGemsCount,
                            }
                            : undefined);
                        floorPriceMetadata = {
                            ian: metadata.ian,
                            id: metadata.id,
                            name: (response === null || response === void 0 ? void 0 : response.name) || '',
                            rarity: metadata.rarity,
                            element: metadata.element,
                            grades: metadata.grade ? [metadata.grade] : undefined,
                            ranks: metadata.rank ? [metadata.rank] : undefined,
                            foil: metadata.foil,
                        };
                        return [4 /*yield*/, getAssetFloorPrice(imxClient, usdcAddress, queue, fees, parseCurrencyQuantity, metadata.tokenType, floorPriceMetadata)];
                    case 8:
                        floorPriceOrder = _g.sent();
                        setFloorPrice((floorPriceOrder === null || floorPriceOrder === void 0 ? void 0 : floorPriceOrder.price)
                            ? {
                                tokenSymbol: floorPriceOrder.price.address === appEnv.ctaTokenAddress
                                    ? CurrencyTokenSymbol.CTA
                                    : CurrencyTokenSymbol.USDC,
                                value: ((_e = floorPriceOrder.price.base) === null || _e === void 0 ? void 0 : _e.displayValue) || '',
                                usdValue: ((_f = floorPriceOrder.price.usd) === null || _f === void 0 ? void 0 : _f.displayValue) || '',
                            }
                            : undefined);
                        if (productCard && productCard.reagentsIan && productCard.reagentsIan.length > 0) {
                            _loop_1 = function (ian) {
                                var relatedCard = cardsData.find(function (card) { return card.ian === ian; });
                                if (relatedCard) {
                                    cardRelatedContent.push(relatedCard);
                                }
                            };
                            for (_i = 0, _c = productCard.reagentsIan; _i < _c.length; _i++) {
                                ian = _c[_i];
                                _loop_1(ian);
                            }
                        }
                        foundRelatedProductCard = (metadata === null || metadata === void 0 ? void 0 : metadata.tokenType) === TokenType.CARD && (metadata === null || metadata === void 0 ? void 0 : metadata.ian)
                            ? cardsData.filter(function (card) {
                                var reagentsIan = card.reagentsIan;
                                return reagentsIan.includes(metadata.ian);
                            })
                            : undefined;
                        if (foundRelatedProductCard) {
                            _loop_2 = function (card) {
                                if (!cardRelatedContent.find(function (_a) {
                                    var ian = _a.ian;
                                    return ian === card.ian;
                                })) {
                                    cardRelatedContent.push(card);
                                }
                            };
                            for (_d = 0, foundRelatedProductCard_1 = foundRelatedProductCard; _d < foundRelatedProductCard_1.length; _d++) {
                                card = foundRelatedProductCard_1[_d];
                                _loop_2(card);
                            }
                        }
                        setRelatedContent(productCard ? cardRelatedContent : undefined);
                        setAsset(response || null);
                        setOwnedByUser(Boolean((response === null || response === void 0 ? void 0 : response.user) && selectedWallet && response.user.toLowerCase() === selectedWallet.address.toLowerCase()));
                        setInitialized(true);
                        setImxLoading(false);
                        return [2 /*return*/];
                }
            });
        });
    }
    function getMetadata() {
        if (!(asset === null || asset === void 0 ? void 0 : asset.metadata))
            return [];
        var metadata = asset === null || asset === void 0 ? void 0 : asset.metadata;
        switch (metadata.tokenType) {
            case TokenType.CARD: {
                var assetMetadata = [
                    {
                        icon: stoneIcon,
                        label: t('common.stones'),
                        value: (shredPreview === null || shredPreview === void 0 ? void 0 : shredPreview.stonesCount) && shredPreview.stonesCount > 0
                            ? shredPreview.stonesCount.toLocaleString('en-US')
                            : '-',
                    },
                    {
                        icon: triselIcon,
                        label: t('common.trisels'),
                        value: (shredPreview === null || shredPreview === void 0 ? void 0 : shredPreview.triselsCount) && shredPreview.triselsCount > 0
                            ? shredPreview.triselsCount.toLocaleString('en-US')
                            : '-',
                    },
                    {
                        icon: rarityAssets[metadata.rarity],
                        label: t('filters.rarity'),
                        value: t("card-metadata.rarity.".concat(metadata === null || metadata === void 0 ? void 0 : metadata.rarity.toLocaleLowerCase().replaceAll('_', '-'))),
                    },
                    {
                        icon: advancementAssets[metadata.advancement],
                        label: t('filters.advancement'),
                        value: t("card-metadata.advancement.".concat(metadata.advancement.toLocaleLowerCase().replaceAll('_', '-'))),
                    },
                    {
                        icon: factionAssets[metadata.faction],
                        label: t('filters.faction'),
                        value: t("card-metadata.faction.".concat(metadata.faction.toLocaleLowerCase().replaceAll('_', '-'))),
                    },
                    {
                        icon: elementAssets[metadata.element],
                        label: t('filters.element'),
                        value: t("card-metadata.element.".concat(metadata.element.toLocaleLowerCase().replaceAll('_', '-'))),
                    },
                    {
                        icon: cardTypeIcon,
                        label: t('filters.card-type'),
                        value: t("card-metadata.card-type.".concat(metadata.cardType.toLocaleLowerCase().replaceAll('_', '-'))),
                    },
                    {
                        icon: metadata.foil ? foilAssets.true : foilAssets.false,
                        label: t('filters.foil'),
                        value: metadata.foil ? t('common.yes') : t('common.no'),
                    },
                ];
                if (metadata.advancement === CardAdvancement.STANDARD) {
                    assetMetadata.push({
                        icon: rankAssets[metadata.rank],
                        label: t('filters.rank'),
                        value: "".concat(t('common.rank'), " ").concat(metadata.rank),
                    });
                }
                if (metadata.advancement !== CardAdvancement.STANDARD) {
                    assetMetadata.push({
                        icon: gradeAssets[metadata.grade],
                        label: t('filters.grade'),
                        value: "".concat(t('common.grade'), " ").concat(metadata.grade),
                    });
                }
                return assetMetadata;
            }
            case TokenType.SOUVENIR_CARD: {
                return [
                    {
                        icon: gradeAssets[metadata.grade],
                        label: t('filters.grade'),
                        value: "".concat(t('common.grade'), " ").concat(metadata.grade),
                    },
                    {
                        icon: metadata.foil ? foilAssets.true : foilAssets.false,
                        label: t('filters.foil'),
                        value: metadata.foil ? t('common.yes') : t('common.no'),
                    },
                ];
            }
            case TokenType.MINT_PASS: {
                return [];
            }
            default: {
                return [];
            }
        }
    }
    function getAssetOrder() {
        return __awaiter(this, void 0, void 0, function () {
            var auxiliaryFee, response, orderPrice;
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (!imxClient || !fees)
                            return [2 /*return*/];
                        auxiliaryFee = fees.buyer > 0
                            ? { auxiliaryFeeRecipients: appEnv.blockchain.feeAddress, auxiliaryFeePercentages: fees.buyer.toString() }
                            : {};
                        return [4 /*yield*/, queue.add(function () {
                                return imxClient.listOrders(__assign({ status: 'active', sellTokenId: tokenId, sellTokenAddress: appEnv.blockchain.collectionAddress, orderBy: 'sell_quantity', direction: 'desc', includeFees: true }, auxiliaryFee));
                            })];
                    case 1:
                        response = _d.sent();
                        orderPrice = response.result.length > 0
                            ? parseCurrencyQuantity(response.result[0].buy.data.quantity_with_fees, response.result[0].buy.data.token_address)
                            : undefined;
                        setOrder(response.result.length > 0 ? response.result[0] : undefined);
                        setAssetOrder(response.result.length > 0 ? response.result[0] : undefined);
                        setPrice(orderPrice
                            ? {
                                tokenSymbol: (_a = orderPrice.base) === null || _a === void 0 ? void 0 : _a.symbol,
                                value: ((_b = orderPrice.base) === null || _b === void 0 ? void 0 : _b.displayValue) || '',
                                usdValue: ((_c = orderPrice.usd) === null || _c === void 0 ? void 0 : _c.displayValue) || '',
                            }
                            : undefined);
                        return [2 /*return*/];
                }
            });
        });
    }
    function getOnSaleOrders(_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var parsedFilters, result, newRefreshCount;
            var options = _b.options, assetData = _b.assetData;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!usdcAddress || !imxClient || !fees || !assetData || !assetData.metadata) {
                            return [2 /*return*/];
                        }
                        setImxLoading(((options === null || options === void 0 ? void 0 : options.refresh) && !options.afterTimeout) || false);
                        setCursors(function (value) { return ((options === null || options === void 0 ? void 0 : options.refresh) ? { cta: undefined, usdc: undefined } : value); });
                        parsedFilters = {
                            tokenType: [assetData.metadata.tokenType],
                            element: assetData.metadata.tokenType === TokenType.CARD ? [assetData.metadata.element] : undefined,
                            grade: assetData.metadata.tokenType === TokenType.CARD && assetData.metadata.grade !== ''
                                ? [assetData.metadata.grade]
                                : [undefined],
                            rank: assetData.metadata.tokenType === TokenType.CARD ? [assetData.metadata.rank.toString()] : undefined,
                            foil: assetData.metadata.tokenType === TokenType.CARD || assetData.metadata.tokenType === TokenType.SOUVENIR_CARD
                                ? [assetData.metadata.foil]
                                : undefined,
                            // animationLevel: assetData.metadata.tokenType === TokenType.CARD ? [assetData.metadata.animationLevel] : undefined,
                            ian: assetData.metadata.tokenType === TokenType.CARD ? [assetData.metadata.ian] : undefined,
                            id: assetData.metadata.tokenType === TokenType.SOUVENIR_CARD ? [assetData.metadata.ian] : undefined,
                            name: [assetData.name || ''],
                        };
                        return [4 /*yield*/, getImxOrders(imxClient, usdcAddress, queue, fees, onSaleOrders, assetData.metadata.tokenType, filters.state.currencyTokens, parsedFilters, 'buy_quantity_with_fees', SortDirection.ASC, cursors, (options === null || options === void 0 ? void 0 : options.refresh) ? undefined : remainings, parseCurrencyQuantity, __assign(__assign({}, options), { sellTokenName: filters.state.searchQuery.value }))];
                    case 1:
                        result = _c.sent();
                        newRefreshCount = (options === null || options === void 0 ? void 0 : options.refresh) ? 1 : refreshCount + 1;
                        setOnSaleOrders(result.orders);
                        setDisplayedOnSaleOrders(result.orders.length > 200 * newRefreshCount ? __spreadArray([], result.orders, true).slice(0, 200 * newRefreshCount) : result.orders);
                        setCursors(result.cursors);
                        setRemainings(result.remainings);
                        setRefreshCount(newRefreshCount);
                        setImxLoading(false);
                        return [2 /*return*/];
                }
            });
        });
    }
    function getOffers() {
        return __awaiter(this, void 0, void 0, function () {
            var auxiliaryFee, tokenAddresses, response;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!imxClient || !fees || !usdcAddress)
                            return [2 /*return*/];
                        auxiliaryFee = fees.buyer > 0
                            ? { auxiliaryFeeRecipients: appEnv.blockchain.feeAddress, auxiliaryFeePercentages: fees.buyer.toString() }
                            : {};
                        tokenAddresses = (_a = {},
                            _a[CurrencyTokenSymbol.CTA] = appEnv.ctaTokenAddress,
                            _a[CurrencyTokenSymbol.USDC] = usdcAddress,
                            _a[CurrencyTokenSymbol.ETH] = '',
                            _a[CurrencyTokenSymbol.IMX] = '',
                            _a);
                        return [4 /*yield*/, queue.add(function () {
                                return imxClient.listOrders(__assign({ status: 'active', buyTokenId: tokenId, buyTokenAddress: appEnv.blockchain.collectionAddress, sellTokenAddress: filters.state.currencyTokens.length === 1 ? tokenAddresses[filters.state.currencyTokens[0]] : undefined, orderBy: 'updated_at', direction: 'desc', includeFees: true }, auxiliaryFee));
                            })];
                    case 1:
                        response = _b.sent();
                        setOffers(response.result);
                        return [2 /*return*/];
                }
            });
        });
    }
    function getRecentlySoldOrders(_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var parsedFilters, result, newRefreshCount;
            var options = _b.options, assetData = _b.assetData;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!usdcAddress || !imxClient || !fees || !assetData || !assetData.metadata) {
                            return [2 /*return*/];
                        }
                        setImxLoading(((options === null || options === void 0 ? void 0 : options.refresh) && !options.afterTimeout) || false);
                        setCursors(function (value) { return ((options === null || options === void 0 ? void 0 : options.refresh) ? { cta: undefined, usdc: undefined } : value); });
                        parsedFilters = {
                            tokenType: [assetData.metadata.tokenType],
                            element: assetData.metadata.tokenType === TokenType.CARD ? [assetData.metadata.element] : undefined,
                            grade: assetData.metadata.tokenType === TokenType.CARD && assetData.metadata.grade !== ''
                                ? [assetData.metadata.grade]
                                : [undefined],
                            rank: assetData.metadata.tokenType === TokenType.CARD ? [assetData.metadata.rank.toString()] : undefined,
                            foil: assetData.metadata.tokenType === TokenType.CARD || assetData.metadata.tokenType === TokenType.SOUVENIR_CARD
                                ? [assetData.metadata.foil]
                                : undefined,
                            // animationLevel: assetData.metadata.tokenType === TokenType.CARD ? [assetData.metadata.animationLevel] : undefined,
                            ian: assetData.metadata.tokenType === TokenType.CARD ? [assetData.metadata.ian] : undefined,
                            id: assetData.metadata.tokenType === TokenType.SOUVENIR_CARD ? [assetData.metadata.ian] : undefined,
                            name: [assetData.name || ''],
                        };
                        return [4 /*yield*/, getImxOrders(imxClient, usdcAddress, queue, fees, recentlySoldOrders, assetData.metadata.tokenType, filters.state.currencyTokens, parsedFilters, 'updated_at', SortDirection.DESC, cursors, (options === null || options === void 0 ? void 0 : options.refresh) ? undefined : remainings, parseCurrencyQuantity, __assign(__assign({}, options), { status: 'filled', sellTokenName: filters.state.searchQuery.value }))];
                    case 1:
                        result = _c.sent();
                        newRefreshCount = (options === null || options === void 0 ? void 0 : options.refresh) ? 1 : refreshCount + 1;
                        setRecentlySoldOrders(result.orders);
                        setDisplayedRecentlySoldOrders(result.orders.length > 200 * newRefreshCount ? __spreadArray([], result.orders, true).slice(0, 200 * newRefreshCount) : result.orders);
                        setCursors(result.cursors);
                        setRemainings(result.remainings);
                        setRefreshCount(newRefreshCount);
                        setImxLoading(false);
                        return [2 /*return*/];
                }
            });
        });
    }
    function getMyOffer() {
        return __awaiter(this, void 0, void 0, function () {
            var auxiliaryFee, result, currencyDetails;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!selectedWallet || !fees)
                            return [2 /*return*/];
                        auxiliaryFee = fees.buyer > 0
                            ? { auxiliaryFeeRecipients: appEnv.blockchain.feeAddress, auxiliaryFeePercentages: fees.buyer.toString() }
                            : {};
                        return [4 /*yield*/, imxClient.listOrders(__assign({ buyTokenId: tokenId, pageSize: 1, status: 'active', includeFees: true, user: selectedWallet.address }, auxiliaryFee))];
                    case 1:
                        result = _c.sent();
                        currencyDetails = result.result.length > 0
                            ? parseCurrencyQuantity(result.result[0].sell.data.quantity_with_fees, result.result[0].sell.data.token_address || '')
                            : undefined;
                        setMyOffer(result.result.length > 0 && currencyDetails
                            ? {
                                offer: result.result[0],
                                price: {
                                    tokenSymbol: currencyDetails.address === appEnv.ctaTokenAddress ? CurrencyTokenSymbol.CTA : CurrencyTokenSymbol.USDC,
                                    value: ((_a = currencyDetails.base) === null || _a === void 0 ? void 0 : _a.displayValue) || '',
                                    usdValue: ((_b = currencyDetails.usd) === null || _b === void 0 ? void 0 : _b.displayValue) || '',
                                },
                            }
                            : undefined);
                        return [2 /*return*/];
                }
            });
        });
    }
    function showBuyNowDialog() {
        if (!asset || !price || !order)
            return;
        var assetMetadata = asset.metadata;
        setDialogProps({
            common: {
                preTitle: t('common.about-to-buy'),
                title: asset.name || '',
                close: { text: t('common.cancel'), action: function () { return setDialogProps(undefined); } },
                actions: [
                    {
                        highlighted: true,
                        text: t('common.confirm'),
                        action: buyNow,
                        disabled: (selectedWallet === null || selectedWallet === void 0 ? void 0 : selectedWallet.address) === order.user,
                    },
                ],
            },
            custom: {
                type: DialogType.BUY_SINGLE_ASSET,
                imgUrl: asset.image_url || '',
                tokenId: asset.token_id,
                tokenAddress: asset.token_address,
                ownerAddress: order.user,
                numbering: assetMetadata === null || assetMetadata === void 0 ? void 0 : assetMetadata.numbering,
                metadata: {
                    rarity: assetMetadata === null || assetMetadata === void 0 ? void 0 : assetMetadata.rarity,
                    advancement: assetMetadata === null || assetMetadata === void 0 ? void 0 : assetMetadata.advancement,
                    element: assetMetadata === null || assetMetadata === void 0 ? void 0 : assetMetadata.element,
                    foil: assetMetadata === null || assetMetadata === void 0 ? void 0 : assetMetadata.foil,
                    rank: (assetMetadata === null || assetMetadata === void 0 ? void 0 : assetMetadata.advancement) === CardAdvancement.STANDARD
                        ? assetMetadata === null || assetMetadata === void 0 ? void 0 : assetMetadata.rank
                        : undefined,
                    grade: (assetMetadata === null || assetMetadata === void 0 ? void 0 : assetMetadata.advancement) !== CardAdvancement.STANDARD
                        ? assetMetadata === null || assetMetadata === void 0 ? void 0 : assetMetadata.grade
                        : undefined,
                    faction: assetMetadata === null || assetMetadata === void 0 ? void 0 : assetMetadata.faction,
                },
                notEnoughCurrency: notEnoughCurrency,
                price: price,
            },
        });
    }
    function buyNow() {
        return __awaiter(this, void 0, void 0, function () {
            var error, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!selectedWallet || !order)
                            return [2 /*return*/];
                        setImxLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, imxActions.createTrade({
                                walletFrom: selectedWallet,
                                orderId: order.order_id,
                            })];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        if (err_1 instanceof Error) {
                            if (err_1.message.includes('USER_VERIFIED_REQUIRED')) {
                                error = t('error.imx.kyc-required');
                            }
                            else if (err_1.message.includes('MPC_WALLET_CTA_TOKEN_IS_LOCKED')) {
                                error = t('error.imx.cta-token-locked');
                            }
                            else if (err_1.message.includes('MPC_WALLET_ASSET_IS_LOCKED')) {
                                error = t('error.imx.asset-locked');
                            }
                            else {
                                error = t('error.generic');
                            }
                            console.log("[buyNow] ".concat(err_1));
                        }
                        return [3 /*break*/, 4];
                    case 4:
                        if (!!error) return [3 /*break*/, 7];
                        return [4 /*yield*/, sleep(4000)];
                    case 5:
                        _a.sent();
                        return [4 /*yield*/, Promise.all([refetchAsset(), getBalances()])];
                    case 6:
                        _a.sent();
                        _a.label = 7;
                    case 7:
                        setImxLoading(false);
                        setDialogProps({
                            common: {
                                title: error ? t('common.error') : t('common.buy-now'),
                                close: { text: t('common.back'), action: hideGenericDialog },
                            },
                            custom: {
                                type: DialogType.SIMPLE,
                                message: error || t('buy-now.success-message'),
                            },
                        });
                        return [2 /*return*/];
                }
            });
        });
    }
    function showMakeOfferDialog() {
        if (!price || !order)
            return;
        setDialogProps({
            common: {
                title: t('common.make-offer'),
                close: { text: t('common.cancel'), action: hideGenericDialog },
                actions: [{ highlighted: true, text: t('common.confirm'), disabled: true }],
            },
            custom: {
                type: DialogType.MAKE_OFFER,
                assetPrice: price,
                makeOfferPrice: makeOfferPrice,
                buyTokenAddress: order.buy.data.token_address || '',
                notEnoughCurrency: false,
                makeOfferPriceTooLow: false,
            },
        });
    }
    function makeOffer(price) {
        return __awaiter(this, void 0, void 0, function () {
            var error, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!tokens || !asset || !order || !selectedWallet)
                            return [2 /*return*/];
                        setImxLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, imxActions.makeOffer({
                                walletFrom: selectedWallet,
                                buyTokenId: asset.token_id,
                                sellQuantity: strFloatToTokenQuantity(price.value, tokens, order.buy.data.token_address || ''),
                                sellTokenAddress: order.buy.data.token_address || '',
                            })];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_2 = _a.sent();
                        console.error(err_2);
                        if (err_2 instanceof Error) {
                            if (err_2.message.includes('USER_VERIFIED_REQUIRED')) {
                                error = t('error.imx.kyc-required');
                            }
                            else if (err_2.message.includes('MPC_WALLET_CTA_TOKEN_IS_LOCKED')) {
                                error = t('error.imx.cta-token-locked');
                            }
                            else if (err_2.message.includes('MPC_WALLET_ASSET_IS_LOCKED')) {
                                error = t('error.imx.asset-locked');
                            }
                            else {
                                error = t('error.generic');
                            }
                            console.log("[makeOffer] ".concat(err_2));
                        }
                        return [3 /*break*/, 4];
                    case 4:
                        if (!!error) return [3 /*break*/, 9];
                        return [4 /*yield*/, sleep(4000)];
                    case 5:
                        _a.sent();
                        return [4 /*yield*/, refetchAsset()];
                    case 6:
                        _a.sent();
                        return [4 /*yield*/, getMyOffer()];
                    case 7:
                        _a.sent();
                        return [4 /*yield*/, getOffers()];
                    case 8:
                        _a.sent();
                        _a.label = 9;
                    case 9:
                        setImxLoading(false);
                        setDialogProps({
                            common: {
                                title: error ? t('common.error') : t('common.make-offer'),
                                close: { text: t('common.back'), action: hideGenericDialog },
                            },
                            custom: {
                                type: DialogType.SIMPLE,
                                message: error || t('make-offer.success-message'),
                            },
                        });
                        return [2 /*return*/];
                }
            });
        });
    }
    function showUpdateOfferDialog() {
        if (!price || !order)
            return;
        setDialogProps({
            common: {
                title: t('common.update-offer'),
                close: { text: t('common.cancel'), action: hideGenericDialog },
                actions: [{ highlighted: true, text: t('common.confirm'), disabled: true }],
            },
            custom: {
                type: DialogType.MAKE_OFFER,
                assetPrice: price,
                makeOfferPrice: makeOfferPrice,
                buyTokenAddress: order.buy.data.token_address || '',
                notEnoughCurrency: false,
                makeOfferPriceTooLow: false,
                update: true,
            },
        });
    }
    function updateOffer(price) {
        return __awaiter(this, void 0, void 0, function () {
            var error, err_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!tokens || !asset || !order || !selectedWallet || !myOffer)
                            return [2 /*return*/];
                        setImxLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, , 6]);
                        return [4 /*yield*/, imxActions.cancelOrder({ walletFrom: selectedWallet, orderId: myOffer.offer.order_id })];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, sleep(5000)];
                    case 3:
                        _a.sent();
                        return [4 /*yield*/, imxActions.makeOffer({
                                walletFrom: selectedWallet,
                                buyTokenId: asset.token_id,
                                sellQuantity: strFloatToTokenQuantity(price.value, tokens, order.buy.data.token_address || ''),
                                sellTokenAddress: order.buy.data.token_address || '',
                            })];
                    case 4:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        err_3 = _a.sent();
                        console.error(err_3);
                        if (err_3 instanceof Error) {
                            if (err_3.message.includes('USER_VERIFIED_REQUIRED')) {
                                error = t('error.imx.kyc-required');
                            }
                            else if (err_3.message.includes('MPC_WALLET_CTA_TOKEN_IS_LOCKED')) {
                                error = t('error.imx.cta-token-locked');
                            }
                            else if (err_3.message.includes('MPC_WALLET_ASSET_IS_LOCKED')) {
                                error = t('error.imx.asset-locked');
                            }
                            else {
                                error = t('error.generic');
                            }
                            console.log("[makeOffer] ".concat(err_3));
                        }
                        return [3 /*break*/, 6];
                    case 6:
                        if (!!error) return [3 /*break*/, 11];
                        return [4 /*yield*/, sleep(4000)];
                    case 7:
                        _a.sent();
                        return [4 /*yield*/, refetchAsset()];
                    case 8:
                        _a.sent();
                        return [4 /*yield*/, getMyOffer()];
                    case 9:
                        _a.sent();
                        return [4 /*yield*/, getOffers()];
                    case 10:
                        _a.sent();
                        _a.label = 11;
                    case 11:
                        setImxLoading(false);
                        setDialogProps({
                            common: {
                                title: error ? t('common.error') : t('common.update-offer'),
                                close: { text: t('common.back'), action: hideGenericDialog },
                            },
                            custom: {
                                type: DialogType.SIMPLE,
                                message: error || t('update-offer.success-message'),
                            },
                        });
                        return [2 /*return*/];
                }
            });
        });
    }
    function showListForSaleDialog() {
        setDialogProps({
            common: {
                title: t('common.list-for-sale'),
                close: { text: t('common.cancel'), action: hideGenericDialog },
                actions: [{ highlighted: true, text: t('common.confirm'), disabled: true }],
            },
            custom: {
                type: DialogType.LIST_FOR_SALE_SINGLE,
                currencyTokenSymbol: listForSaleCurrencyTokenSymbol,
                setCurrencyTokenSymbol: setListForSaleCurrencyTokenSymbol,
                price: listForSalePrice,
                shredStonesCount: shredPreview === null || shredPreview === void 0 ? void 0 : shredPreview.stonesCount,
                usdFloorPrice: floorPrice === null || floorPrice === void 0 ? void 0 : floorPrice.usdValue,
            },
        });
    }
    function showEditListingDialog() {
        if (!order)
            return;
        setListForSaleCurrencyTokenSymbol(order.buy.data.token_address === appEnv.ctaTokenAddress ? CurrencyTokenSymbol.CTA : CurrencyTokenSymbol.USDC);
        setDialogProps({
            common: {
                title: t('common.edit-listing'),
                close: { text: t('common.cancel'), action: hideGenericDialog },
                actions: [{ highlighted: true, text: t('common.confirm'), disabled: true }],
            },
            custom: {
                type: DialogType.LIST_FOR_SALE_SINGLE,
                currencyTokenSymbol: listForSaleCurrencyTokenSymbol,
                setCurrencyTokenSymbol: setListForSaleCurrencyTokenSymbol,
                price: listForSalePrice,
                shredStonesCount: shredPreview === null || shredPreview === void 0 ? void 0 : shredPreview.stonesCount,
                usdFloorPrice: floorPrice === null || floorPrice === void 0 ? void 0 : floorPrice.usdValue,
                edit: true,
            },
        });
    }
    function listForSale(price, symbol, edit) {
        return __awaiter(this, void 0, void 0, function () {
            var error, err_4, title, successMessage;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!tokens || !usdcAddress || !asset || !selectedWallet)
                            return [2 /*return*/];
                        setImxLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, imxActions.listForSale({
                                walletFrom: selectedWallet,
                                sellTokenId: asset.token_id,
                                buyQuantity: strFloatToTokenQuantity(price.value, tokens, symbol === CurrencyTokenSymbol.CTA ? appEnv.ctaTokenAddress : usdcAddress),
                                buyTokenAddress: symbol === CurrencyTokenSymbol.CTA ? appEnv.ctaTokenAddress : usdcAddress,
                            })];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_4 = _a.sent();
                        console.error(err_4);
                        if (err_4 instanceof Error) {
                            if (err_4.message.includes('USER_VERIFIED_REQUIRED')) {
                                error = t('error.imx.kyc-required');
                            }
                            else if (err_4.message.includes('MPC_WALLET_CTA_TOKEN_IS_LOCKED')) {
                                error = t('error.imx.cta-token-locked');
                            }
                            else if (err_4.message.includes('MPC_WALLET_ASSET_IS_LOCKED')) {
                                error = t('error.imx.asset-locked');
                            }
                            else {
                                error = t('error.generic');
                            }
                            console.log("[listForSale] ".concat(err_4));
                        }
                        return [3 /*break*/, 4];
                    case 4:
                        if (!!error) return [3 /*break*/, 7];
                        return [4 /*yield*/, sleep(4000)];
                    case 5:
                        _a.sent();
                        return [4 /*yield*/, refetchAsset()];
                    case 6:
                        _a.sent();
                        _a.label = 7;
                    case 7:
                        title = edit ? t('common.edit-listing') : t('common.list-for-sale');
                        successMessage = edit ? t('list-for-sale.edit.success-message') : t('list-for-sale.success-message');
                        setImxLoading(false);
                        setDialogProps({
                            common: {
                                title: error ? t('common.error') : title,
                                close: { text: t('common.back'), action: hideGenericDialog },
                            },
                            custom: {
                                type: DialogType.SIMPLE,
                                message: error || successMessage,
                            },
                        });
                        return [2 /*return*/];
                }
            });
        });
    }
    function showCancelListingDialog() {
        setDialogProps({
            common: {
                title: t('common.cancel-listing'),
                close: { text: t('common.cancel'), action: function () { return setDialogProps(undefined); } },
                actions: [{ highlighted: true, text: t('common.confirm'), action: cancelListing }],
            },
            custom: {
                type: DialogType.SIMPLE,
                message: t('cancel-listing.single.message'),
            },
        });
    }
    function cancelListing() {
        return __awaiter(this, void 0, void 0, function () {
            var error, err_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!order || !selectedWallet)
                            return [2 /*return*/];
                        setImxLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, imxActions.cancelOrder({ walletFrom: selectedWallet, orderId: order.order_id })];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_5 = _a.sent();
                        if (err_5 instanceof Error) {
                            if (err_5.message.includes('USER_VERIFIED_REQUIRED')) {
                                error = t('error.imx.kyc-required');
                            }
                            else if (err_5.message.includes('MPC_WALLET_CTA_TOKEN_IS_LOCKED')) {
                                error = t('error.imx.cta-token-locked');
                            }
                            else if (err_5.message.includes('MPC_WALLET_ASSET_IS_LOCKED')) {
                                error = t('error.imx.asset-locked');
                            }
                            else {
                                error = t('error.generic');
                            }
                            console.log("[cancelListing] ".concat(err_5));
                        }
                        return [3 /*break*/, 4];
                    case 4:
                        if (!!error) return [3 /*break*/, 7];
                        return [4 /*yield*/, sleep(4000)];
                    case 5:
                        _a.sent();
                        return [4 /*yield*/, refetchAsset()];
                    case 6:
                        _a.sent();
                        _a.label = 7;
                    case 7:
                        setImxLoading(false);
                        setDialogProps({
                            common: {
                                title: error ? t('common.error') : t('common.cancel-listing'),
                                close: { text: t('common.back'), action: hideGenericDialog },
                            },
                            custom: {
                                type: DialogType.SIMPLE,
                                message: error || t('cancel-listing.single.success-message'),
                            },
                        });
                        return [2 /*return*/];
                }
            });
        });
    }
    function showTransferDialog() {
        setDialogProps({
            common: {
                title: t('common.transfer'),
                close: { text: t('common.cancel'), action: hideGenericDialog },
                actions: [{ highlighted: true, text: t('common.confirm'), disabled: true }],
            },
            custom: {
                type: DialogType.TRANSFER_ASSET,
                walletToAddress: walletToTransferAddress,
                invalidAddress: false,
            },
        });
    }
    function transfer(toAddress) {
        return __awaiter(this, void 0, void 0, function () {
            var error, err_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!selectedWallet || !asset)
                            return [2 /*return*/];
                        setImxLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, imxActions.transferERC721({
                                walletFrom: selectedWallet,
                                toAddress: toAddress.value,
                                tokenIds: [asset.token_id],
                            })];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_6 = _a.sent();
                        if (err_6 instanceof Error) {
                            if (err_6.message.includes('USER_VERIFIED_REQUIRED')) {
                                error = t('error.imx.kyc-required');
                            }
                            else if (err_6.message.includes('MPC_WALLET_CTA_TOKEN_IS_LOCKED')) {
                                error = t('error.imx.cta-token-locked');
                            }
                            else if (err_6.message.includes('MPC_WALLET_ASSET_IS_LOCKED')) {
                                error = t('error.imx.asset-locked');
                            }
                            else {
                                error = t('error.generic');
                            }
                            console.log("[transfer] ".concat(err_6));
                        }
                        return [3 /*break*/, 4];
                    case 4:
                        if (!!error) return [3 /*break*/, 7];
                        return [4 /*yield*/, sleep(4000)];
                    case 5:
                        _a.sent();
                        return [4 /*yield*/, refetchAsset()];
                    case 6:
                        _a.sent();
                        _a.label = 7;
                    case 7:
                        setImxLoading(false);
                        setDialogProps({
                            common: {
                                title: error ? t('common.error') : t('common.success'),
                                close: { text: t('common.back'), action: hideGenericDialog },
                            },
                            custom: {
                                type: DialogType.SIMPLE,
                                message: error || t('transfer-asset.single.success-message'),
                            },
                        });
                        return [2 /*return*/];
                }
            });
        });
    }
    function showCancelOfferDialog(orderId) {
        setDialogProps({
            common: {
                title: t('common.cancel-offer'),
                close: { text: t('common.cancel'), action: function () { return setDialogProps(undefined); } },
                actions: [{ highlighted: true, text: t('common.confirm'), action: function () { return cancelOffer(orderId); } }],
            },
            custom: {
                type: DialogType.SIMPLE,
                message: t('cancel-offer.message'),
            },
        });
    }
    function cancelOffer(orderId) {
        return __awaiter(this, void 0, void 0, function () {
            var error, err_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!selectedWallet)
                            return [2 /*return*/];
                        setImxLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, imxActions.cancelOrder({ walletFrom: selectedWallet, orderId: orderId })];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_7 = _a.sent();
                        if (err_7 instanceof Error) {
                            if (err_7.message.includes('USER_VERIFIED_REQUIRED')) {
                                error = t('error.imx.kyc-required');
                            }
                            else if (err_7.message.includes('MPC_WALLET_CTA_TOKEN_IS_LOCKED')) {
                                error = t('error.imx.cta-token-locked');
                            }
                            else if (err_7.message.includes('MPC_WALLET_ASSET_IS_LOCKED')) {
                                error = t('error.imx.asset-locked');
                            }
                            else {
                                error = t('error.generic');
                            }
                            console.log("[cancelOffer] ".concat(err_7));
                        }
                        return [3 /*break*/, 4];
                    case 4:
                        if (!!error) return [3 /*break*/, 9];
                        return [4 /*yield*/, sleep(4000)];
                    case 5:
                        _a.sent();
                        return [4 /*yield*/, refetchAsset()];
                    case 6:
                        _a.sent();
                        return [4 /*yield*/, getOffers()];
                    case 7:
                        _a.sent();
                        return [4 /*yield*/, getMyOffer()];
                    case 8:
                        _a.sent();
                        _a.label = 9;
                    case 9:
                        setImxLoading(false);
                        setDialogProps({
                            common: {
                                title: error ? t('common.error') : t('common.cancel-offer'),
                                close: { text: t('common.back'), action: hideGenericDialog },
                            },
                            custom: {
                                type: DialogType.SIMPLE,
                                message: error || t('cancel-offer.success-message'),
                            },
                        });
                        return [2 /*return*/];
                }
            });
        });
    }
    function showAcceptOfferDialog(orderId) {
        setDialogProps({
            common: {
                title: t('common.accept-offer'),
                close: { text: t('common.cancel'), action: function () { return setDialogProps(undefined); } },
                actions: [{ highlighted: true, text: t('common.confirm'), action: function () { return acceptOffer(orderId); } }],
            },
            custom: {
                type: DialogType.SIMPLE,
                message: t('accept-offer.message'),
            },
        });
    }
    function acceptOffer(orderId) {
        return __awaiter(this, void 0, void 0, function () {
            var error, err_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!selectedWallet)
                            return [2 /*return*/];
                        setImxLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, imxActions.createTrade({ walletFrom: selectedWallet, orderId: orderId })];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_8 = _a.sent();
                        if (err_8 instanceof Error) {
                            if (err_8.message.includes('USER_VERIFIED_REQUIRED')) {
                                error = t('error.imx.kyc-required');
                            }
                            else if (err_8.message.includes('MPC_WALLET_CTA_TOKEN_IS_LOCKED')) {
                                error = t('error.imx.cta-token-locked');
                            }
                            else if (err_8.message.includes('MPC_WALLET_ASSET_IS_LOCKED')) {
                                error = t('error.imx.asset-locked');
                            }
                            else {
                                error = t('error.accept-offer');
                            }
                            console.log("[acceptOffer] ".concat(err_8));
                        }
                        return [3 /*break*/, 4];
                    case 4:
                        if (!!error) return [3 /*break*/, 8];
                        return [4 /*yield*/, sleep(4000)];
                    case 5:
                        _a.sent();
                        return [4 /*yield*/, refetchAsset()];
                    case 6:
                        _a.sent();
                        return [4 /*yield*/, getOffers()];
                    case 7:
                        _a.sent();
                        _a.label = 8;
                    case 8:
                        setImxLoading(false);
                        setDialogProps({
                            common: {
                                title: error ? t('common.error') : t('common.accept-offer'),
                                close: { text: t('common.back'), action: hideGenericDialog },
                            },
                            custom: {
                                type: DialogType.SIMPLE,
                                message: error || t('accept-offer.single.success-message'),
                            },
                        });
                        return [2 /*return*/];
                }
            });
        });
    }
    function showHistoryDialog() {
        var metadata = asset === null || asset === void 0 ? void 0 : asset.metadata;
        if (!(metadata === null || metadata === void 0 ? void 0 : metadata.history) || metadata.tokenType !== TokenType.CARD)
            return;
        var history = JSON.parse(metadata.history);
        var historyItems = [];
        var _loop_3 = function (item) {
            var exisingItem = historyItems.find(function (historyItem) { return historyItem.id === item; });
            if (exisingItem) {
                exisingItem.count += 1;
            }
            else {
                historyItems.push({ id: item, count: 1 });
            }
        };
        for (var _i = 0, history_1 = history; _i < history_1.length; _i++) {
            var item = history_1[_i];
            _loop_3(item);
        }
        setDialogProps({
            common: {
                title: t('common.history'),
                close: { text: t('common.back'), action: hideGenericDialog },
            },
            custom: {
                type: DialogType.ASSET_CARD_HISTORY,
                items: historyItems,
                foil: metadata.foil || false,
            },
        });
    }
    function hideGenericDialog() {
        setDialogProps(undefined);
        makeOfferPrice.setValue('');
        setListForSaleCurrencyTokenSymbol(CurrencyTokenSymbol.USDC);
        listForSalePrice.setValue('');
        walletToTransferAddress.setValue('');
    }
    return {
        asset: asset,
        metadata: getMetadata(),
        onSaleOrders: displayedOnSaleOrders,
        offers: offers,
        recentlySoldOrders: displayedRecentlySoldOrders,
        supply: supply,
        initialized: initialized,
        assetOrder: assetOrder,
        price: price,
        ownedByUser: ownedByUser,
        myOffer: ownedByUser || !order ? undefined : myOffer,
        relatedContent: relatedContent,
        shredPreview: shredPreview,
        showBuyNowDialog: showBuyNowDialog,
        showMakeOfferDialog: showMakeOfferDialog,
        showUpdateOfferDialog: showUpdateOfferDialog,
        showListForSaleDialog: showListForSaleDialog,
        showEditListingDialog: showEditListingDialog,
        showCancelListingDialog: showCancelListingDialog,
        showTransferDialog: showTransferDialog,
        showCancelOfferDialog: showCancelOfferDialog,
        showAcceptOfferDialog: showAcceptOfferDialog,
        showHistoryDialog: showHistoryDialog,
        getOnSaleOrders: getOnSaleOrders,
    };
}
